// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plan-card[data-v-439b4e15]{height:100%;display:flex;flex-direction:column}.plan-card--compact[data-v-439b4e15]{padding:16px 14px}.plan-card--error[data-v-439b4e15]{border:1px dashed #fca5a5;background:#fef2f2;text-align:center;justify-content:center;align-items:center;padding:28px 20px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
